
/* @ngInject */
export default class ConfigService {

    constructor() {}

    public threeDSecureCheck(offerId? :string) {
        return true;
    }
}


// WEBPACK FOOTER //
// src/app/common/services/config.service.ts